// extracted by mini-css-extract-plugin
export default {"table":"Series180_table__UgXQh","header":"Series180_header__4vECs","valueCell":"Series180_valueCell__PdpTN","lastLit":"Series180_lastLit__NCJH8"};